<template>
  <layout background-class="sf-bg-background">
    <template v-slot:title>
      <h1 class="sf-sb">{{ $t('contacts-page.page-title') }}</h1>
    </template>

    <p class="subtitle">{{ $t('contacts-page.contacts-description') }}</p>

    <div class="wrapper">
      <contacts-customer-service/>
      <contacts-working-hours/>
    </div>
  </layout>
</template>

<script>
import Layout from '~lib/src/layouts/blank';
import ContactsCustomerService from '~/components/contacts/contacts-customer-service';
import ContactsWorkingHours from '~/components/contacts/contacts-working-hours.vue';
import { Meta } from '~/mixins/meta';
import { meta } from '~/utils/meta';

export default {
  name: 'Contacts',
  components: { ContactsWorkingHours, ContactsCustomerService, Layout },
  mixins: [Meta(meta.contacts_page)],
  nuxtI18n: {
    paths: {
      ru: '/contacty',
      kg: '/bailanysh-maalymat',
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 40px;
}

.wrapper {
  @include tablet {
    display: flex;
    gap: 30px;
  }

  @include tablet-only {
    @media (orientation: portrait) {
      flex-wrap: wrap;
    }
  }
}

::v-deep .blank__title {
  border-top-color: transparent;
}
</style>
